<div class="onboarding-container">
    <div class="title">
        <div>{{ 'Complete the registration to the energy community'|i18n }}</div>
        <div>{{ onboardingMember.community_name }}</div>
    </div>
    <div *ngIf="onboardingMember.step === ONBOARDING_STEPS.SMS_CONFIRMATION" fxLayoutAlign="center">
        <form [formGroup]="totpForm">
            <div *ngIf="!onboardingMember.sms_totp_generated">
                <div fxLayout="column" fxLayoutGap="20px" class="panel mt-52 mb-42" fxLayoutAlign="start center">
                    <div class="panel-title">{{ 'Confirm your identity with SMS'|i18n }}</div>
                    <div class="panel-subtitle">{{ 'Get a confirmation code to create your account.'|i18n }}</div>
                    <div class="mt-10">
                        <button app-large-primary-button (click)="onRequestTotp()">
                            {{ 'REQUEST CODE'|i18n }}
                        </button>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px" class="panel-sub-text mt-20"
                         *appVar="memberMobileNumber as mobile">
                        <div *ngIf="mobile">{{ 'You will receive a text message with the code at {0}.'|i18n:mobile }}</div>
                        <div>{{ 'The code expires after 5 minutes'|i18n }}</div>
                    </div>
                </div>
            </div>
            <div *ngIf="onboardingMember.sms_totp_generated">
                <div fxLayout="column" fxLayoutGap="20px" class="panel mt-52 mb-42" fxLayoutAlign="start center">
                    <div class="panel-title">{{ 'Enter code'|i18n }}</div>
                    <div class="panel-subtitle">{{ 'Enter the code received via SMS'|i18n }}</div>
                    <div fxFlex app-input-container>
                        <input app-input formControlName="smsTotp" class="form-input" type="text" maxlength="6">
                        <div app-error *ngIf="errorCount > 0">
                            {{ 'You entered an invalid code'|i18n }}
                        </div>
                    </div>
                    <div class="mt-10">
                        <button app-large-primary-button (click)="onValidateTotp()"
                                [disabled]="totpForm.controls.smsTotp.invalid">
                            {{ 'CONTINUE'|i18n }}
                        </button>
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px" class="panel-sub-text mt-20"
                     *appVar="memberMobileNumber as mobile">
                    <div *ngIf="errorCount < 3" class="sub-panel-sub-text">{{ 'Didn\'t receive the code?'|i18n }}</div>
                    <div fxLayout="row" fxLayoutAlign="center center" *ngIf="errorCount > 2" fxLayoutGap="30px"
                         class="error-panel">
                        <app-icon class="error-icon" name="fas-info-circle"></app-icon>
                        <div>{{ 'The code you entered may be incorrect or expired. Request a new code.'|i18n }}</div>
                    </div>
                    <button app-ghost-button (click)="onRequestTotp(true)" [disabled]="timeToSleep < TOTP_TIMEOUT">
                        {{ 'Request new code'|i18n }}
                    </button>

                    <ng-container *ngIf="!timerMessage">
                        <div *ngIf="mobile"
                             class="mt-20">{{ 'You will receive a text message with the code at {0}.'|i18n:mobile }}
                        </div>
                        <div>{{ 'The code expires after 5 minutes'|i18n }}</div>
                    </ng-container>
                    <div *ngIf="timerMessage" fxLayout="row wrap" fxLayout.lt-md="column"
                         fxLayoutAlign.lt-md="center center">
                        <span>{{ 'You will be able to request a new code in '|i18n }}</span>
                        &nbsp;<span class="timer">{{ timerMessage }}</span>&nbsp;
                        <span>{{ ' minutes.'|i18n }}</span>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div *ngIf="onboardingMember.step === ONBOARDING_STEPS.USER_REGISTRATION" class="application-form-container"
         fxLayout="column" fxLayoutAlign="center">
        <!--        <div class="text-0">{{'To register you will need'|i18n}}:</div>
                <ul class="mt-2 mb-20 text-0">
                    <li>{{'the POD code of your electricity utilities'|i18n}}</li>
                    <li>{{'a digital copy of your personal documents'|i18n}}</li>
                    <li>{{'your electricity supply bills for the past year'|i18n}}</li>
                    <li>{{'the total annual consumption in kWh of your utilities'|i18n}}</li>
                    <li>{{'your IBAN code'|i18n}}</li>
                    <li>{{'the license plate data of your photovoltaic system, if any'|i18n}}</li>
                    <li>{{'printer and scanner (or camera)'|i18n}}</li>
                </ul>-->
        <div #topContent class="text-0 mb-20">{{ 'Fields with an asterisk are required'|i18n }}.</div>

        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center" fxLayoutAlign.lt-md="start start"
             fxLayoutGap="10px" class="main-container stepper pt-20">
            <ng-container *ngFor="let step of STEPS; let stepIndex=index">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
                    <div [ngClass]="currentStep >= stepIndex ? 'circle' : 'circle disabled'"
                         fxLayoutAlign="center center">
                        <div class="number" fxLayoutAlign="center center">{{ stepIndex + 1 }}</div>
                    </div>
                    <div [ngClass]="currentStep >= stepIndex ? 'stepper-subtitle' : 'stepper-subtitle disabled'">
                        {{ (step[0])|i18n }}
                    </div>
                </div>
                <div *ngIf="stepIndex+1 !== STEPS.length" class="line" fxFlex fxShow.lt-md="false"></div>
                <div *ngIf="stepIndex+1 !== STEPS.length" class="bar" fxFlex fxShow.gt-sm="false"></div>
            </ng-container>
        </div>

        <ng-container *ngIf="STEPS[this.currentStep][0] === PERSONAL_DATA">
            <form [formGroup]="personalDataForm">
                <div class="title-1">{{ STEPS[currentStep][0]|i18n }}</div>
                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign.gt-sm="space-between start"
                     fxLayoutGap.lt-md="30px"
                     class="panel">
                    <div fxLayout="column" fxLayoutGap="30px" fxFlex="60">
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40" class="bold unstyled-text">{{ 'Juridical type'|i18n }}:</div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ currentJuridicalType|ecMemberJuridicalType|genericPipe }}
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row" *ngIf="currentLegalForm" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40" class="bold unstyled-text">{{ 'Legal form'|i18n }}:</div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ currentLegalForm|ecMemberLegalFormType|genericPipe }}
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row" *ngIf="currentSubjectType" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40" class="bold unstyled-text">{{ 'Subject type'|i18n }}:</div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ currentSubjectType|ecMemberSubjectType|genericPipe }}
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row" *ngIf="currentEntitySubtype" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40" class="bold unstyled-text">{{ 'Entity subtype'|i18n }}:</div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ currentEntitySubtype|ecMemberEntitySubtype|genericPipe }}
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40"
                                     class="bold unstyled-text">{{ ((currentJuridicalType === ECJuridicalType.CORPORATE_ENTITY ? 'Signatory\'s first name' : 'First name')|i18n) + ':' }}
                                </div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ onboardingMember.member.personal_data.first_name }}
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40"
                                     class="bold unstyled-text">{{ ((currentJuridicalType === ECJuridicalType.CORPORATE_ENTITY ? 'Signatory\'s last name' : 'Last name')|i18n) + ':' }}
                                </div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ onboardingMember.member.personal_data.last_name }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isCompany" fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40" class="bold unstyled-text">{{ ('Company name'|i18n) + ':' }}</div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ onboardingMember.member.personal_data.company_name }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!onboardingMember.member.personal_data.address" fxLayout="column" fxLayoutGap="16px"
                             fxFlex="60">
                            <div fxLayout="row" fxLayoutAlign="center center">
                                <div fxLayout="column" fxLayoutGap="12px" fxFlex="60" fxFlex.lt-md="80">
                                    <div class="bold unstyled-text">
                                        {{ ((currentJuridicalType === ECJuridicalType.CORPORATE_ENTITY ? 'Headquarters address' : 'Residential address')|i18n) + ':*' }}
                                    </div>
                                    <div>
                                        <app-google-maps-address-autocomplete [formControlRef]="addressFormControl"
                                                                              (addressChange)="addressChange($event)"
                                                                              [restrictSearch]="false">
                                        </app-google-maps-address-autocomplete>
                                        <div *ngIf="isControlOK(personalDataForm,'address')" app-error>
                                            {{ 'Invalid address'|i18n }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="onboardingMember.member.personal_data.address" fxLayout="row"
                             fxLayoutAlign="center center">
                            <div fxLayout="column" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40" class="bold unstyled-text">
                                    {{ ((currentJuridicalType === ECJuridicalType.CORPORATE_ENTITY ? 'Headquarters address' : 'Residential address')|i18n) + ':' }}
                                </div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ addressToString(onboardingMember.member.personal_data.address) }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEnabled(ConfigurableField.BIRTH_DATE) && !isEditable(ConfigurableField.BIRTH_DATE, onboardingMember.member.personal_data.birth_date)"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40"
                                     class="bold unstyled-text">{{ ((currentJuridicalType === ECJuridicalType.CORPORATE_ENTITY ? 'Signatory\'s birth date' : 'Birth date')|i18n) + ':' }}
                                </div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ onboardingMember.member.personal_data.birth_date|i18nDate }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEditable(ConfigurableField.BIRTH_DATE, onboardingMember.member.personal_data.birth_date)"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="column" fxLayoutGap="10px" fxFlex="60" fxFlex.lt-md="80">
                                <div class="unstyled-text">{{ mkFieldName(ConfigurableField.BIRTH_DATE, currentJuridicalType === ECJuridicalType.CORPORATE_ENTITY ? 'Signatory\'s birth date' : 'Birth date') }}
                                </div>
                                <div app-input-container>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                                        <input app-input [matDatepicker]="birthDate" formControlName="birthDate"
                                               [max]="maxBirthDate">
                                        <mat-datepicker-toggle matSuffix [for]="birthDate">
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #birthDate></mat-datepicker>
                                    </div>
                                    <div *ngIf="isControlOK(personalDataForm,'birthDate')" app-error>
                                        {{ 'Invalid birth date'|i18n }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEnabled(ConfigurableField.BIRTH_COUNTRY) && !isEditable(ConfigurableField.BIRTH_COUNTRY, onboardingMember.member.personal_data.birth_country)" fxLayout="row"
                             fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40"
                                     class="bold unstyled-text">{{ (birthCountryLabel|i18n) + ':' }}
                                </div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ getCountryNameByCode(onboardingMember.member.personal_data.birth_country) }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEditable(ConfigurableField.BIRTH_COUNTRY, onboardingMember.member.personal_data.birth_country)" fxLayout="row"
                             fxLayoutAlign="center center">
                            <div fxLayout="column" fxLayoutGap="10px" fxFlex="60" fxFlex.lt-md="80">
                                <div class="unstyled-text">{{ mkFieldName(ConfigurableField.BIRTH_COUNTRY, birthCountryLabel) }}
                                </div>
                                <div app-input-container>
                                    <app-autocomplete-dropdown formControlName="birthCountry"
                                                               [values]="countries"
                                                               [placeholder]="birthCountryLabel|i18n"
                                                               [triggerDisplayFn]="getCountryName"
                                                               [valueDisplayFn]="getCountryName"
                                                               [valueSearchFn]="getCountryName"
                                                               (valueChange)="onChangeBirthCountry()">
                                    </app-autocomplete-dropdown>
                                    <div *ngIf="isControlOK(personalDataForm,'birthCountry')" app-error>
                                        {{ 'Invalid birth country'|i18n }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEnabled(ConfigurableField.BIRTH_MUNICIPALITY) && !isEditable(ConfigurableField.BIRTH_MUNICIPALITY, onboardingMember.member.personal_data.birth_municipality) && bornInItaly"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40"
                                     class="bold unstyled-text">{{ (birthMunicipalityLabel|i18n) + ':' }}
                                </div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ onboardingMember.member.personal_data.birth_municipality }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEditable(ConfigurableField.BIRTH_MUNICIPALITY, onboardingMember.member.personal_data.birth_municipality) && bornInItaly"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="column" fxLayoutGap="10px" fxFlex="60" fxFlex.lt-md="80">
                                <div class="unstyled-text">{{ mkFieldName(ConfigurableField.BIRTH_MUNICIPALITY, birthMunicipalityLabel) }}
                                </div>
                                <div app-input-container>
                                    <app-autocomplete-dropdown formControlName="birthMunicipality"
                                                               [values]="MUNICIPALITIES"
                                                               [placeholder]="birthMunicipalityLabel|i18n"
                                                               [triggerDisplayFn]="getMunicipalityName"
                                                               [valueDisplayFn]="getMunicipalityName"
                                                               [valueSearchFn]="getMunicipalityName">
                                    </app-autocomplete-dropdown>
                                    <div *ngIf="isControlOK(personalDataForm,'birthMunicipality')" app-error>
                                        {{ 'Invalid birth municipality'|i18n }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="30px" fxFlex="60">
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40" class="bold unstyled-text">{{ ('Email'|i18n) + ':' }}</div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ onboardingMember.member.personal_data.email }}
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40" class="bold unstyled-text">{{ ('Mobile'|i18n) + ':' }}</div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ onboardingMember.member.personal_data.mobile_number }}
                                </div>
                            </div>
                        </div>
                        <ng-container *ngIf="isEditable(ConfigurableField.VAT_CODE, onboardingMember.member.personal_data.piva) && isCompany">
                            <div fxLayout="row" fxLayoutAlign="center center">
                                <div fxLayout="column" fxLayoutGap="10px" fxFlex="60" fxFlex.lt-md="80">
                                    <div class="unstyled-text">{{ mkFieldName(ConfigurableField.VAT_CODE, 'VAT number') }}</div>
                                    <div app-input-container>
                                        <input app-input formControlName="vatNumber" [maxLength]="VAT_NUMBER_MAX_CHARS">
                                        <div *ngIf="isControlOK(personalDataForm,'vatNumber')" app-error>
                                            {{ 'Invalid VAT number'|i18n }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="isEnabled(ConfigurableField.VAT_CODE) && !isEditable(ConfigurableField.VAT_CODE, onboardingMember.member.personal_data.piva) && isCompany">
                            <div fxLayout="row" fxLayoutAlign="center center">
                                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                     fxFlex.lt-md="80">
                                    <div fxFlex="40" class="bold unstyled-text">{{ ('VAT number'|i18n) + ':' }}</div>
                                    <div fxFlex="60"
                                         class="unstyled-text">{{ onboardingMember.member.personal_data.piva }}
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <div *ngIf="isEditable(ConfigurableField.TAX_CODE, onboardingMember.member.personal_data.cf)"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="column" fxLayoutGap="10px" fxFlex="60" fxFlex.lt-md="80">
                                <div class="unstyled-text">{{ mkFieldName(ConfigurableField.TAX_CODE, 'Tax code') }}</div>
                                <div app-input-container>
                                    <input app-input formControlName="taxCode" [maxLength]="taxIdMaxChars">
                                    <div *ngIf="isControlOK(personalDataForm,'taxCode')" app-error>
                                        {{ 'Invalid tax code'|i18n }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEnabled(ConfigurableField.TAX_CODE) && !isEditable(ConfigurableField.TAX_CODE, onboardingMember.member.personal_data.cf)"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40" class="bold unstyled-text">{{ ('Tax code'|i18n) + ':' }}</div>
                                <div fxFlex="60" class="unstyled-text">{{ onboardingMember.member.personal_data.cf }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEditable(ConfigurableField.PEC, onboardingMember.member.personal_data.pec)"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="column" fxLayoutGap="10px" fxFlex="60" fxFlex.lt-md="80">
                                <div class="unstyled-text">{{ mkFieldName(ConfigurableField.PEC, 'PEC') }}</div>
                                <div app-input-container>
                                    <input app-input formControlName="pec" [maxLength]="EMAIL_MAX_CHARS">
                                    <div *ngIf="isControlOK(personalDataForm,'pec')" app-error>
                                        {{ 'Invalid PEC'|i18n }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEnabled(ConfigurableField.PEC) && !isEditable(ConfigurableField.PEC, onboardingMember.member.personal_data.pec)"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40" class="bold unstyled-text">{{ ('PEC'|i18n) + ':' }}</div>
                                <div fxFlex="60" class="unstyled-text">{{ onboardingMember.member.personal_data.pec }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEditable(ConfigurableField.PHONE_NUMBER, onboardingMember.member.personal_data.telephone_number)"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="column" fxLayoutGap="10px" fxFlex="60" fxFlex.lt-md="80">
                                <div class="unstyled-text">{{ mkFieldName(ConfigurableField.PHONE_NUMBER, 'Telephone number') }}</div>
                                <div app-input-container>
                                    <input app-input formControlName="telephone_number" [maxLength]="MOBILE_MAX_CHARS">
                                    <div *ngIf="isControlOK(personalDataForm,'telephone_number')" app-error>
                                        {{ 'Invalid telephone number'|i18n }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEnabled(ConfigurableField.PHONE_NUMBER) && !isEditable(ConfigurableField.PHONE_NUMBER, onboardingMember.member.personal_data.telephone_number)"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40" class="bold unstyled-text">{{ ('Telephone number'|i18n) + ':' }}</div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ onboardingMember.member.personal_data.telephone_number }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEditable(ConfigurableField.IBAN, onboardingMember.member.personal_data.iban)"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="column" fxLayoutGap="10px" fxFlex="60" fxFlex.lt-md="80">
                                <div class="unstyled-text">{{ mkFieldName(ConfigurableField.IBAN, 'IBAN')}}</div>
                                <div app-input-container>
                                    <input app-input formControlName="iban" [maxLength]="IBAN_MAX_CHARS">
                                    <div *ngIf="isControlOK(personalDataForm,'iban')" app-error>
                                        {{ 'Invalid IBAN'|i18n }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEnabled(ConfigurableField.IBAN) && !isEditable(ConfigurableField.IBAN, onboardingMember.member.personal_data.iban)"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40" class="bold unstyled-text">{{ ('IBAN'|i18n) + ':' }}</div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ onboardingMember.member.personal_data.iban }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEditable(ConfigurableField.ATECO_CODE, onboardingMember.member.personal_data.ateco_code) && isCompany"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="column" fxLayoutGap="10px" fxFlex="60" fxFlex.lt-md="80">
                                <div class="unstyled-text">{{ mkFieldName(ConfigurableField.ATECO_CODE, 'ATECO code') }}</div>
                                <div app-input-container>
                                    <input app-input formControlName="atecoCode" [maxLength]="ATECO_MAX_CHARS">
                                    <div *ngIf="isControlOK(personalDataForm,'atecoCode')" app-error>
                                        {{ 'Invalid ATECO code'|i18n }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEnabled(ConfigurableField.ATECO_CODE) && !isEditable(ConfigurableField.ATECO_CODE, onboardingMember.member.personal_data.ateco_code) && isCompany"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40" class="bold unstyled-text">{{ ('ATECO code'|i18n) + ':' }}</div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ onboardingMember.member.personal_data.ateco_code }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEditable(ConfigurableField.SIGNATORY_TAX_CODE, onboardingMember.member.signatory_tax_code) && currentJuridicalType === ECJuridicalType.CORPORATE_ENTITY"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="column" fxLayoutGap="10px" fxFlex="60" fxFlex.lt-md="80">
                                <div class="unstyled-text">{{ mkFieldName(ConfigurableField.SIGNATORY_TAX_CODE, 'Signatory\'s tax code') }}</div>
                                <div app-input-container>
                                    <input app-input formControlName="signatoryTaxCode" [maxLength]="TAX_ID_MAX_CHARS">
                                    <div *ngIf="isControlOK(personalDataForm,'signatoryTaxCode')" app-error>
                                        {{ 'Invalid tax code'|i18n }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEnabled(ConfigurableField.SIGNATORY_TAX_CODE) && !isEditable(ConfigurableField.SIGNATORY_TAX_CODE, onboardingMember.member.signatory_tax_code) && currentJuridicalType === ECJuridicalType.CORPORATE_ENTITY"
                             fxLayout="row" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex="60"
                                 fxFlex.lt-md="80">
                                <div fxFlex="40" class="bold unstyled-text">{{ ('Signatory\'s tax code'|i18n) + ':' }}</div>
                                <div fxFlex="60"
                                     class="unstyled-text">{{ onboardingMember.member.signatory_tax_code }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="onboardingMember.member.documents.length > 0" fxLayout="row"
                             fxLayoutAlign="center center">
                            <div fxLayout="column" fxLayoutGap="10px" fxFlex="60" fxFlex.lt-md="80">
                                <div *ngFor="let d of onboardingMember.member.documents" fxLayout="row">
                                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                                        <div class="bold unstyled-text">{{ d.document_type|ecDocumentTypeI18n }}:</div>
                                        <div class="unstyled-text">{{ d.filename }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="isDefined(subjectDocumentConfig)">
                    <ng-container *ngFor="let doc of missingDocs">
                        <div fxLayout="column" fxLayoutGap="30px" class="panel">
                            <div class="title-2 ml-36">
                                {{ doc.name|ecDocumentType|i18n }}
                                <span *ngIf="doc.optional">({{ 'optional'|i18n }})</span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center center">
                                <div fxLayout="column" fxLayoutGap="10px" fxFlex="40" fxFlex.lt-md="80">
                                    <div class="unstyled-text">{{ 'Upload document'|i18n }}{{ !doc.optional ? ':*' : ':' }}</div>
                                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center"
                                         fxLayoutGap="10px">
                                        <input #fileSelect type="file" style="display: none"
                                               [accept]="ACCEPTED_MIME_TYPES"
                                               (change)="onUploadDocumentFile(doc.name, $event)">
                                        <button app-small-primary-button (click)="fileSelect.click()" type="button">
                                            {{ (uploadedFileName(doc.name) ? 'Change file' : 'Upload file')|i18n }}
                                        </button>
                                        <div *ngIf="uploadedFileName(doc.name)">{{ uploadedFileName(doc.name) }}</div>
                                        <button *ngIf="uploadedFileName(doc.name)" app-icon-button
                                                class="app-button-alert"
                                                [title]="'Remove file'|i18n"
                                                (click)="onClickRemoveDocument(doc.name)" type="button">
                                            <app-icon name="far-trash-alt"></app-icon>
                                        </button>
                                    </div>
                                    <div class="text-2" fxLayout="row">
                                        {{ '(Max {0} MB. Accepts only {1}.)'|i18n:MAX_FILE_MB:mimeTypesNames }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </form>
        </ng-container>

        <ng-container *ngIf="STEPS[this.currentStep][0] === YOUR_UTILITIES">
            <div class="title-1">{{ STEPS[currentStep][0]|i18n }}</div>
            <form *ngFor="let pod of onboardingMember.member.pods; let i = index"
                  fxLayout="column" fxLayoutAlign="center center" class="panel" fxLayoutGap="10px"
                  [formGroup]="podControls[i]">
                <div fxLayout="row" fxLayoutAlign="start start" class="title-2 w-90 mb-20">POD {{ pod.pod }}</div>
                <div fxLayoutGap="25px" fxLayout="column" fxLayoutAlign="start start" class="w-30"
                     [ngClass.lt-md]="'w-80'">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="10px">
                        <div class="bold unstyled-text">{{ ('POD utility type'|i18n) + ':' }}</div>
                        <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text" [ngClass.lt-md]="'w-100'">
                            {{ isDefined(pod.pod_utility_type) ? (pod.pod_utility_type|genericPipe) : ('Undefined'|i18n) }}
                        </div>
                    </div>

                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
                        <div class="bold unstyled-text">{{ ('Utility address'|i18n) + ':' }}</div>
                        <div class="unstyled-text">{{ isDefined(pod.address) ? addressToString(pod.address) : ('Undefined'|i18n) }}</div>
                    </div>

                    <div *ngIf="isEditable(ConfigurableField.WIFI, pod.has_wifi)"
                         fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="10px">
                        <div class="unstyled-text">{{ mkFieldName(ConfigurableField.WIFI, 'Wi-Fi') }}</div>
                        <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text" [ngClass.lt-md]="'w-100'">
                            <mat-slide-toggle app-toggle formControlName="hasWifi" class="fix-width"></mat-slide-toggle>
                        </div>
                    </div>
                    <div *ngIf="isEnabled(ConfigurableField.WIFI) && !isEditable(ConfigurableField.WIFI, pod.has_wifi)"
                         fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="10px">
                        <div class="bold unstyled-text">{{ ('Wi-Fi'|i18n) + ':' }}</div>
                        <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text"
                             [ngClass.lt-md]="'w-100'">{{ (pod.has_wifi ? 'Yes' : 'No')|i18n }}
                        </div>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="10px">
                        <div class="bold unstyled-text">{{ 'Energy profile'|i18n }}:</div>
                        <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text" [ngClass.lt-md]="'w-100'"
                             *appVar="getEnergyProfile(pod) as podEnergyProfile">
                            {{ podEnergyProfile ? (podEnergyProfile|i18n) : ('Undefined'|i18n) }}
                        </div>
                    </div>

                    <div *ngIf="isEditable(ConfigurableField.VOLTAGE, pod.resource.pod.voltage)"
                         fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column" fxLayoutGap="25px">
                        <div class="unstyled-text">{{ mkFieldName(ConfigurableField.VOLTAGE, 'Voltage connection') }}</div>
                        <div app-input-container>
                            <mat-radio-group class="set-gap" formControlName="podVoltage" fxLayout.gt-xs="row wrap"
                                             fxLayout.xs="column"
                                             fxLayoutGap.gt-xs="35px" fxLayoutGap.xs="15px" color="primary">
                                <mat-radio-button app-radio-button *ngFor="let pv of podVoltages"
                                                  name="podVoltage"
                                                  [value]="pv.value" class="unstyled-text radio-option">
                                    {{ pv.name|i18n }}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div *ngIf="isEnabled(ConfigurableField.VOLTAGE) && !isEditable(ConfigurableField.VOLTAGE, pod.resource.pod.voltage)"
                         fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="10px">
                        <div class="bold unstyled-text">{{ ('Voltage connection'|i18n) + ':' }}</div>
                        <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text"
                             [ngClass.lt-md]="'w-100'">{{ getVoltageName(pod.resource.pod.voltage)|i18n }}
                        </div>
                    </div>

                    <div *ngIf="isEditable(ConfigurableField.PHASES, pod.resource.pod.phases)"
                         fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column" fxLayoutGap="25px">
                        <div class="unstyled-text">{{ mkFieldName(ConfigurableField.PHASES, 'Phases') }}</div>
                        <div app-input-container>
                            <mat-radio-group class="set-gap" formControlName="podPhase" fxLayout.gt-xs="row wrap"
                                             fxLayout.xs="column"
                                             fxLayoutGap.gt-xs="35px" fxLayoutGap.xs="15px" color="primary">
                                <mat-radio-button app-radio-button *ngFor="let pp of podPhases"
                                                  name="podPhase"
                                                  [value]="pp.value" class="unstyled-text radio-option">
                                    {{ pp.name|i18n }}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div *ngIf="isEnabled(ConfigurableField.PHASES) && !isEditable(ConfigurableField.PHASES, pod.resource.pod.phases)"
                         fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="10px">
                        <div class="bold unstyled-text">{{ ('Phases'|i18n) + ':' }}</div>
                        <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text"
                             [ngClass.lt-md]="'w-100'">{{ getPhasesName(pod.resource.pod.phases)|i18n }}
                        </div>
                    </div>

                    <div *ngIf="isEditable(ConfigurableField.CONTRACTUAL_POWER, pod.resource.pod.contractual_power)"
                         fxLayout="column" fxLayoutAlign="start start"
                         fxLayoutGap="5px" class="w-100">
                        <div class="unstyled-text">{{ mkFieldName(ConfigurableField.CONTRACTUAL_POWER, 'Contractual power') }}</div>
                        <div fxLayout="row" fxLayoutAlign="start center" app-input-container class="w-100"
                             fxLayoutGap="10px">
                            <mat-select app-small-select formControlName="contractualPower">
                                <mat-option *ngFor="let cp of cPowerValues" [value]="cp.value">
                                    {{ cp.name }}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <ng-container *ngIf="isEnabled(ConfigurableField.CONTRACTUAL_POWER) && !isEditable(ConfigurableField.CONTRACTUAL_POWER, pod.resource.pod.contractual_power)">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="10px">
                            <div class="bold unstyled-text">{{ ('Contractual power'|i18n) + ':' }}</div>
                            <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text"
                                 [ngClass.lt-md]="'w-100'">{{ pod.resource.pod.contractual_power|niceValue:'W' }}
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="pod.resource && (isProsumer(pod.resource) || isProducer(pod.resource))">
                        <ng-container *ngFor="let plant of pod.resource.plants; let j = index">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="10px">
                                <div class="bold unstyled-text">{{ 'Plant type'|i18n }} {{ j + 1 }}:</div>
                                <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text"
                                     [ngClass.lt-md]="'w-100'">
                                    {{ getPlantType(plant)|i18n }}
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="10px">
                                <div class="bold unstyled-text">{{ 'Power plant'|i18n }} {{ j + 1 }}:</div>
                                <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text"
                                     [ngClass.lt-md]="'w-100'">
                                    {{ plant.plant.nominal_power ? (plant.plant.nominal_power|niceValue:'kW') : ('Undefined'|i18n) }}
                                </div>
                            </div>
                            <div *ngIf="isEnabled(ConfigurableField.PRODUCTION_POD) && !isEditable(ConfigurableField.PRODUCTION_POD, plant.plant.production_pod)"
                                 fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="10px">
                                <div class="bold unstyled-text">{{ ('Production POD'|i18n) + ' ' + (j + 1) + ':' }}</div>
                                <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text"
                                     [ngClass.lt-md]="'w-100'">
                                    {{ plant.plant.production_pod }}
                                </div>
                            </div>
                            <div *ngIf="isEditable(ConfigurableField.PRODUCTION_POD, plant.plant.production_pod)"
                                 fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px" class="w-100">
                                <div class="unstyled-text">{{ mkFieldName(ConfigurableField.PRODUCTION_POD, ('Production POD'|i18n) + ' ' + (j + 1)) }}</div>
                                <div app-input-container class="w-100">
                                    <input app-input [formControlName]="'pod'+plant.id+'Production'"
                                           [maxLength]="POD_MAX_CHARS">
                                    <div *ngIf="isControlOK(podControls[i],'pod'+plant.id+'Production')" app-error>
                                        {{ 'Invalid POD production'|i18n }}
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>

                    <!-- Land registry data -->
                    <div *ngIf="isEditable(ConfigurableField.LAND_REGISTRY_SECTION, pod.land_registry_data?.section)"
                         fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px" class="w-100">
                        <div class="unstyled-text">{{ mkFieldName(ConfigurableField.LAND_REGISTRY_SECTION, 'Land registry section') }}</div>
                        <div app-input-container class="w-100">
                            <input app-input formControlName="landRegistrySection"
                                   [maxLength]="LAND_REGISTRY_MAX_CHARS">
                            <div *ngIf="isControlOK(podControls[i],'landRegistrySection')" app-error>
                                {{ 'Invalid section'|i18n }}
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="isEnabled(ConfigurableField.LAND_REGISTRY_SECTION) && !isEditable(ConfigurableField.LAND_REGISTRY_SECTION, pod.land_registry_data?.section)">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="10px">
                            <div class="bold unstyled-text">{{ ('Land registry section'|i18n) + ':' }}</div>
                            <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text"
                                 [ngClass.lt-md]="'w-100'">{{ pod.land_registry_data.section }}
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="isEditable(ConfigurableField.LAND_REGISTRY_SHEET, pod.land_registry_data?.sheet)" fxLayout="column" fxLayoutAlign="start start"
                         fxLayoutGap="5px" class="w-100">
                        <div class="unstyled-text">{{ mkFieldName(ConfigurableField.LAND_REGISTRY_SHEET, 'Land registry sheet') }}</div>
                        <div app-input-container class="w-100">
                            <input app-input formControlName="landRegistrySheet" [maxLength]="LAND_REGISTRY_MAX_CHARS">
                            <div *ngIf="isControlOK(podControls[i],'landRegistrySheet')" app-error>
                                {{ 'Invalid sheet'|i18n }}
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="isEnabled(ConfigurableField.LAND_REGISTRY_SHEET) && !isEditable(ConfigurableField.LAND_REGISTRY_SHEET, pod.land_registry_data?.sheet)">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="10px">
                            <div class="bold unstyled-text">{{ ('Land registry sheet'|i18n) + ':' }}</div>
                            <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text"
                                 [ngClass.lt-md]="'w-100'">{{ pod.land_registry_data.sheet }}
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="isEditable(ConfigurableField.LAND_REGISTRY_PARTICLE, pod.land_registry_data?.particle)"
                         fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px" class="w-100">
                        <div class="unstyled-text">{{ mkFieldName(ConfigurableField.LAND_REGISTRY_PARTICLE, 'Land registry particle') }}</div>
                        <div app-input-container class="w-100">
                            <input app-input formControlName="landRegistryParticle"
                                   [maxLength]="LAND_REGISTRY_MAX_CHARS">
                            <div *ngIf="isControlOK(podControls[i],'landRegistryParticle')" app-error>
                                {{ 'Invalid particle'|i18n }}
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="isEnabled(ConfigurableField.LAND_REGISTRY_PARTICLE) && !isEditable(ConfigurableField.LAND_REGISTRY_PARTICLE, pod.land_registry_data?.particle)">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="10px">
                            <div class="bold unstyled-text">{{ ('Land registry particle'|i18n) + ':' }}</div>
                            <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text"
                                 [ngClass.lt-md]="'w-100'">{{ pod.land_registry_data.particle }}
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="isEditable(ConfigurableField.LAND_REGISTRY_SUBDIVISION, pod.land_registry_data?.subdivision)"
                         fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px" class="w-100">
                        <div class="unstyled-text">{{ mkFieldName(ConfigurableField.LAND_REGISTRY_SUBDIVISION, 'Land registry subdivision') }}</div>
                        <div app-input-container class="w-100">
                            <input app-input formControlName="landRegistrySubdivision"
                                   [maxLength]="LAND_REGISTRY_MAX_CHARS">
                            <div *ngIf="isControlOK(podControls[i],'landRegistrySubdivision')" app-error>
                                {{ 'Invalid subdivision'|i18n }}
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="isEnabled(ConfigurableField.LAND_REGISTRY_SUBDIVISION) && !isEditable(ConfigurableField.LAND_REGISTRY_SUBDIVISION, pod.land_registry_data?.subdivision)">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="10px">
                            <div class="bold unstyled-text">{{ ('Land registry subdivision'|i18n) + ':' }}</div>
                            <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text"
                                 [ngClass.lt-md]="'w-100'">{{ pod.land_registry_data.subdivision }}
                            </div>
                        </div>
                    </ng-container>

                    <div *ngIf="isEditable(ConfigurableField.ENERGY_PROVIDER, pod.energy_provider)"
                         fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px" class="w-100">
                        <div class="unstyled-text">{{ mkFieldName(ConfigurableField.ENERGY_PROVIDER, 'What is your energy provider for this utility', '?') }}</div>
                        <div app-input-container class="w-100">
                            <input app-input formControlName="podProvider" [maxLength]="DEFAULT_MAX_CHARS">
                            <div *ngIf="isControlOK(podControls[i],'podProvider')" app-error>
                                {{ 'Invalid energy provider'|i18n }}
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="isEnabled(ConfigurableField.ENERGY_PROVIDER) && !isEditable(ConfigurableField.ENERGY_PROVIDER, pod.energy_provider)">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="10px">
                            <div class="bold unstyled-text">{{ ('Energy provider'|i18n) + ':' }}</div>
                            <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text"
                                 [ngClass.lt-md]="'w-100'">{{ pod.energy_provider }}
                            </div>
                        </div>
                    </ng-container>
                </div>
            </form>
        </ng-container>

        <ng-container *ngIf="STEPS[this.currentStep][0] === ENERGY_PROFILING">
            <div class="title-1">{{ STEPS[currentStep][0]|i18n }}</div>
            <form *ngFor="let pod of profilablePods; let i = index" fxLayout="column" fxLayoutAlign="center center"
                  class="panel" fxLayoutGap="10px" [formGroup]="podProfileControls[i]"
                  (change)="detectFormChanges(podProfileControls[i])">
                <div fxLayout="row" fxLayoutAlign="start start" class="title-2 w-90 mb-20">POD {{ pod.pod }}</div>
                <div fxLayout="row" fxLayoutAlign="start start" class="unstyled-text w-90">
                    {{ mkFieldName(ConfigurableField.ENERGY_PROFILE, 'Define the consumption profile of this utility') }}
                </div>
                <div fxLayoutGap="25px" fxLayout="column" fxLayoutAlign="start start" class="w-500 w-30 mt-30"
                     [ngClass.lt-md]="'w-80'">
                    <mat-radio-group formControlName="podProfileRadio" fxLayout="column" fxLayoutGap="16px"
                                     class="w-100"
                                     (change)="detectChanges($event, podProfileControls[i], pod.pod_utility_type)">
                        <mat-radio-button
                                *ngIf="!podIsReligiousInstitution(pod) && !podIsThirdSector(pod) && !podIsOther(pod)"
                                app-radio-button fxLayoutAlign="start center" [value]="0"
                                [checked]="getPodProfileRadio(podProfileControls[i]) === 0"
                                [ngClass]="isFirstRadioSelected(podProfileControls[i]) ? '' : 'disabled-text'"
                                class="size-16 radio-option">
                            <ng-container *ngIf="!isCompany">
                                {{ 'Household appliances data'|i18n }}:
                            </ng-container>
                            <ng-container *ngIf="isCompany">
                                <ng-container *ngIf="pod.pod_utility_type === ECPodUtilityType.CONDOMINIUM">
                                    {{ 'Number of households'|i18n }}:
                                </ng-container>
                                <ng-container *ngIf="pod.pod_utility_type === ECPodUtilityType.SME_FACTORY">
                                    {{ 'Number of employees'|i18n }}:
                                </ng-container>
                                <ng-container
                                        *ngIf="(pod.pod_utility_type !== ECPodUtilityType.SME_FACTORY) && (pod.pod_utility_type !== ECPodUtilityType.CONDOMINIUM) && (pod.pod_utility_type !== ECPodUtilityType.RESIDENTIAL)">
                                    {{ 'Surface area of the utility site'|i18n }}:
                                </ng-container>
                            </ng-container>
                        </mat-radio-button>
                        <ng-container *ngIf="!isCompany">
                            <div fxLayout="row" fxLayoutAlign="start center" class="set-margin"
                                 [ngClass]="isFirstRadioSelected(podProfileControls[i]) ? '' : 'disabled-text'">
                                <div fxLayout="column" fxLayoutGap="10px" fxFlex.lt-md="80" class="w-100">
                                    <div class="size-14">{{ ('Number of people using the utility'|i18n) + ':' }}</div>
                                    <div app-input-container class="w-50">
                                        <input app-input [formControlName]="'podPeople'"
                                               [maxLength]="PROFILATIONS_MAX_CHARS"
                                               [attr.disabled]="secondButton.checked ? '' : null">
                                        <div *ngIf="isControlOK(podProfileControls[i], 'podPeople')" app-error>
                                            {{ 'Invalid value'|i18n }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" class="set-margin"
                                 [ngClass]="isFirstRadioSelected(podProfileControls[i]) ? '' : 'disabled-text'">
                                <div fxLayout="column" fxLayoutGap="10px" fxFlex.lt-md="80" class="w-100">
                                    <div class="size-14">{{ ('Number of televisions'|i18n) + ':' }}</div>
                                    <div app-input-container class="w-50">
                                        <input app-input [formControlName]="'podTv'"
                                               [maxLength]="PROFILATIONS_MAX_CHARS"
                                               [attr.disabled]="secondButton.checked ? '' : null">
                                        <div *ngIf="isControlOK(podProfileControls[i], 'podTv')" app-error>
                                            {{ 'Invalid value'|i18n }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" class="set-margin"
                                 [ngClass]="isFirstRadioSelected(podProfileControls[i]) ? '' : 'disabled-text'">
                                <div fxLayout="column" fxLayoutGap="10px" fxFlex.lt-md="80" class="w-100">
                                    <div class="size-14">{{ ('Number of computers'|i18n) + ':' }}</div>
                                    <div app-input-container class="w-50">
                                        <input app-input [formControlName]="'podPc'"
                                               [maxLength]="PROFILATIONS_MAX_CHARS"
                                               [attr.disabled]="secondButton.checked ? '' : null">
                                        <div *ngIf="isControlOK(podProfileControls[i], 'podPc')" app-error>
                                            {{ 'Invalid value'|i18n }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" class="set-margin"
                                 [ngClass]="isFirstRadioSelected(podProfileControls[i]) ? '' : 'disabled-text'">
                                <div fxLayout="column" fxLayoutGap="10px" fxFlex.lt-md="80" class="w-100">
                                    <div class="size-14">{{ ('Number of air conditioners'|i18n) + ':' }}</div>
                                    <div app-input-container class="w-50">
                                        <input app-input [formControlName]="'podAc'"
                                               [maxLength]="PROFILATIONS_MAX_CHARS"
                                               [attr.disabled]="secondButton.checked ? '' : null">
                                        <div *ngIf="isControlOK(podProfileControls[i], 'podAc')" app-error>
                                            {{ 'Invalid value'|i18n }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" class="set-margin"
                                 [ngClass]="isFirstRadioSelected(podProfileControls[i]) ? '' : 'disabled-text'">
                                <div fxLayout="column" fxLayoutGap="10px" fxFlex.lt-md="80">
                                    <mat-checkbox class="font-14 radio-option" app-checkbox
                                                  [formControlName]="'podDishwasher'" [disabled]="secondButton.checked">
                                        <div>{{ 'Dishwasher use'|i18n }}</div>
                                    </mat-checkbox>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" class="set-margin"
                                 [ngClass]="isFirstRadioSelected(podProfileControls[i]) ? '' : 'disabled-text'">
                                <div fxLayout="column" fxLayoutGap="10px" fxFlex.lt-md="80">
                                    <mat-checkbox class="font-14 radio-option" app-checkbox
                                                  [formControlName]="'podHeater'" [disabled]="secondButton.checked">
                                        <div>{{ 'Heater use'|i18n }}</div>
                                    </mat-checkbox>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container
                                *ngIf="isCompany && !podIsReligiousInstitution(pod) && !podIsThirdSector(pod) && !podIsOther(pod)">
                            <div fxLayout="row" fxLayoutAlign="start center" class="set-margin">
                                <div fxLayout="column" fxLayoutGap="10px" fxFlex.lt-md="80" class="w-70">
                                    <mat-select app-small-select formControlName="customRange"
                                                [disabled]="secondButton.checked"
                                                (selectionChange)="detectFormChanges(podProfileControls[i])">
                                        <mat-option *ngFor="let val of podUtilitiesMap[pod.pod]"
                                                    [value]="val.value">{{ val.name }}
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container
                                *ngIf="!isCompany || (!podIsReligiousInstitution(pod) && !podIsThirdSector(pod) && !podIsOther(pod))">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <div [ngClass]="isFirstRadioSelected(podProfileControls[i]) ? '' : 'disabled-text'"
                                     class="set-margin size-16">{{ 'Estimated consumption: {0} kWh/year'|i18n: podProfileControls[i].controls.podEstimatedYearlyConsumption.value }}
                                </div>
                            </div>
                        </ng-container>

                        <mat-radio-button app-radio-button #secondButton fxLayoutAlign="start center"
                                          [ngClass]="!isFirstRadioSelected(podProfileControls[i]) ? '' : 'disabled-text'"
                                          class="size-16 radio-option mt-20" [value]="1"
                                          [checked]="getPodProfileRadio(podProfileControls[i]) === 1">
                            {{ 'Yearly consumption'|i18n }}:
                        </mat-radio-button>
                        <div fxLayout="row" fxLayoutAlign="start center" class="set-margin">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center"
                                 fxLayoutAlign.lt-md="start start" fxLayoutGap="10px" fxFlex.lt-md="80" class="w-100">
                                <div app-input-container>
                                    <input app-input [formControlName]="'podYearlyConsumption'"
                                           [maxLength]="TOTAL_CONSUMPTION_MAX_CHARS"
                                           [attr.disabled]="(podIsReligiousInstitution(pod) || podIsThirdSector(pod) || podIsOther(pod)) ? null : isFirstRadioSelected(podProfileControls[i]) ? '' : null">
                                    <div *ngIf="isControlOK(podProfileControls[i], 'podYearlyConsumption')" app-error>
                                        {{ 'Invalid value'|i18n }}
                                    </div>
                                </div>
                                <div [ngClass]="!isFirstRadioSelected(podProfileControls[i]) ? '' : 'disabled-text'">
                                    kWh/{{ ('year'|i18n) }}
                                </div>
                            </div>
                        </div>
                    </mat-radio-group>
                </div>
            </form>
        </ng-container>

        <ng-container *ngIf="STEPS[this.currentStep][0] === CREDENTIALS">
            <div class="title-1">{{ STEPS[currentStep][0]|i18n }}</div>
            <div class="unstyled-text ml mb-20">{{ 'Choose a password to log in to the platform with the given username'|i18n }}
                .
            </div>
            <form fxLayout="column" fxLayoutAlign="center center" class="panel" fxLayoutGap="30px"
                  [formGroup]="credentialsForm">
                <div class="w-50" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center"
                     fxLayoutAlign.lt-md="start start" fxLayoutGap.gt-md="30px" fxLayoutGap.lt-md="10px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">
                        <span class="bold form-text">{{ 'Username'|i18n }}:</span>
                    </div>
                    <div fxFlex>
                        <span class="form-text">{{ onboardingMember.member.personal_data.email }}</span>
                    </div>
                    <div fxFlex.gt-md="30"></div>
                </div>
                <div class="w-50" fxLayout="column">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap.gt-md="30px" fxLayoutGap.lt-md="10px">
                        <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">
                            <span class="form-text">{{ 'Choose a password:'|i18n }}</span>
                        </div>
                        <div fxFlex app-input-container>
                            <input app-input class="form-input" formControlName="password"
                                   [type]="hidePsw ? 'password' : 'text'"
                                   maxlength="64" autocomplete="off">
                            <div fxLayout="row">
                                <div fxFlex [ngClass]="strength.clazz">
                                    <mat-progress-bar class="progress-bar" ngClass.lt-lg="progress-bar-mobile"
                                                      [mode]="'determinate'" [value]="strength.quality">
                                    </mat-progress-bar>
                                </div>
                            </div>
                        </div>
                        <div class="icon-container" fxLayout="row" fxLayoutAlign="center center"
                             (click)="togglePsw()">
                            <fa-icon [hidden]="hidePsw" class="eye" [icon]="faEye"></fa-icon>
                            <fa-icon [hidden]="!hidePsw" class="eye" [icon]="faEyeSlash"></fa-icon>
                        </div>
                        <div fxFlex.gt-md="30"></div>
                    </div>
                    <div fxLayout="row" fxLayoutGap.gt-md="30px" fxLayoutGap.lt-md="10px">
                        <div fxFlex="30"></div>
                        <div fxFlex>
                            <div *ngFor="let message of pwErrorMessages" app-error>
                                <span class="psw-criteria">{{ message }}</span>
                            </div>
                            <div app-error *ngIf="pwdContainsForbiddenWords">
                                <span class="psw-criteria">
                                    {{ 'Password must not contain first name, last name, e-mail and the following common words:'|i18n }}
                                </span>
                                <div>
                                    <span *ngFor="let word of forbiddenWords; index as i" class="psw-criteria">
                                        {{ word + (i === forbiddenWords.length - 1 ? '.' : ', ') }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-50" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap.lt-md="10px"
                     fxLayoutGap.gt-md="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">
                        <span class="form-text">{{ 'Enter password again:'|i18n }}</span>
                    </div>
                    <div fxFlex app-input-container>
                        <input app-input class="form-input" formControlName="repeatedPassword"
                               [type]="hideRepPsw ? 'password' : 'text'" (paste)="false" (copy)="false"
                               (cut)="false"
                               maxlength="64" autocomplete="off">
                        <div app-error *ngIf="pwdNotEqual">
                            {{ 'The two passwords must match'|i18n }}
                        </div>
                    </div>
                    <div class="icon-container" fxLayout="row" fxLayoutAlign="center center"
                         (click)="toggleRepPsw()">
                        <fa-icon [hidden]="hideRepPsw" class="eye" [icon]="faEye"></fa-icon>
                        <fa-icon [hidden]="!hideRepPsw" class="eye" [icon]="faEyeSlash"></fa-icon>
                    </div>
                    <div fxFlex.gt-md="30"></div>
                </div>
            </form>
        </ng-container>

        <ng-container *ngIf="STEPS[this.currentStep][0] === ACCEPTANCE">
            <div class="title-1">{{ STEPS[currentStep][0]|i18n }}</div>
            <div class="unstyled-text ml mb-20">{{ 'View and accept the following conditions'|i18n }}.</div>
            <form fxLayout="column" class="panel" fxLayoutGap="30px" [formGroup]="acceptanceForm">
                <div *ngIf="missingEcPP" fxLayout="row">
                    <div fxFlex.gt-sm="40" fxFlex.lt-md="10"></div>
                    <mat-checkbox app-checkbox formControlName="bigPP" fxFlex>
                        <div>{{ 'Acceptance'|i18n }}
                            <span>
                                <a href="javascript:void(0);" rel="noopener noreferrer"
                                   (click)="openDocLink(bigPPLink)">
                                    {{ 'Privacy policy*'|i18n }}
                                </a>
                            </span>
                        </div>
                    </mat-checkbox>
                </div>
                <div *ngFor="let dta of ecDocuments" fxLayout="row">
                    <div fxFlex.gt-sm="40" fxFlex.lt-md="10"></div>
                    <mat-checkbox app-checkbox [formControlName]="'acceptance_' + dta.document_type" fxFlex>
                        <div>{{ 'Acceptance'|i18n }}
                            <span>
                                <a href="javascript:void(0);" rel="noopener noreferrer" (click)="openDocument(dta.id)">
                                    {{ dta.document_type + (isOptional(dta) ? '' : '*') }}
                                </a>
                            </span>
                        </div>
                    </mat-checkbox>
                </div>
            </form>
        </ng-container>

        <div fxLayout="row" fxLayoutAlign="space-evenly center" class="mt-42">
            <button *ngIf="currentStep > 0" app-ghost-button type="button"
                    (click)="prevStep(topContent)">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <app-icon name="fas-arrow-left"></app-icon>
                    <span>{{ 'Back'|i18n }}</span>
                </div>
            </button>
            <button *ngIf="currentStep < (STEPS.length - 1)" app-primary-button type="button"
                    [disabled]="!isNextEnabled"
                    (click)="nextStep(topContent)">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <span>{{ 'Next'|i18n }}</span>
                    <app-icon name="fas-arrow-right" class="right-icon"></app-icon>
                </div>
            </button>
            <button *ngIf="currentStep === (STEPS.length - 1)" app-primary-button type="button"
                    [disabled]="!isNextEnabled"
                    (click)="onSubmit()">
                {{ 'Save'|i18n }}
            </button>
        </div>
    </div>
</div>


<ng-template #spinner let-data="data" let-close="close">
    <app-spinner [spinnerDataSubj]="data"
                 (closeSpinner)="close()">
    </app-spinner>
</ng-template>



